<template lang="pug">
.blog__container
  .blog__col-left
    h1.blog__title.blog__title_desktop {{ title }}
    p.blog__subtitle
      | Чтобы вам было удобно,
      br
      | мы разделили статьи блога
      br
      | по темам:
    div(v-for="tag in tags" :key="tag.id")
      NuxtLink.blog__tag(:to="{ query: { tag: tag.name } }")  {{ tag.name_ru + " (" + tag.count + ")" }}
    template(v-if="!isSubsLetterSend")
      h3.blog__title-form
        | Рассылка
      p.blog__subtitle.blog__subtitle_desktop
        | Отправляем письма
        br
        | со смыслом
        br
        | один раз в месяц
      p.blog__subtitle.blog__subtitle_mobile
        | Отправляем письма
        br
        | со смыслом
        | один раз в месяц

      form(@submit.prevent="applySubEmail").subscribe__form
        input(type="mail" placeholder="E-mail" v-model="subscribeEmail" required).base-input
        BaseCheckbox(:name="'Я согласен получать письма от блога NEKIDAEM'" :value="false" v-model="permissionToSend" :required="true").subscribe__checkbox
        BaseBtn.blog__btn-aside Подписаться на рассылку
    template(v-if="isSubsLetterSend")
      picture
        source(type="image/webp" srcset="~assets/images/png/letter_send.webp")
        source(type="image/png" srcset="~assets/images/png/letter_send.png")
        img(src="~assets/images/png/letter_send.webp").subscribe__send-img
      p.blog__subtitle.blog__subtitle_email-send
        | Вам на почту отправлено
        br
        | подтверждение рассылки.
    template(v-if="isSubsLetterNotSend && !isSubsLetterSend && isSubsLetterNotSendReason === 'Provided email exists already'")
      p.blog__subtitle.blog__subtitle_email-not-send
        | Пользователь с таким email
        br
        | уже подписан на рассылку.
    template(v-if="isSubsLetterNotSend && !isSubsLetterSend && isSubsLetterNotSendReason === ''")
      p.blog__subtitle.blog__subtitle_email-not-send
        | При подписке на рассылку возникла ошибка.
        br
        | Повторите попытку позже.
    DialogCard(:css="dialogCardStyles").blog__dialog-card
      | Подписывайтесь
      br
      | на наш блог
      br
      | в&#8197;
      a.blog__link(href="https://t.me/nekidaem_official") Телеграме
  .blog__list
    MediaCard(v-for="post in content" :key="post.id" :card="post").blog__list-item
  .blog__footer
    BaseFooter(:formValue="footer_data")
  </template>

<script setup>
import { useBlogStore } from '~~/stores/blog'
import { storeToRefs } from 'pinia'

const route = useRoute()
const query_tag = route.query.tag

const subscribeEmail = ref('')
const permissionToSend = ref(false)

const dialogCardStyles = computed(() => {
  return {
    borderColor: '#99e2ff',
    color: '#787979',
    padding: '30px 30px 30px 50px',
    width: '100%',
    fontSize: '16px',
    lineHeight: '1.4',
  }
})

const blogStore = useBlogStore()
await blogStore.setIndexPage(query_tag)
const { title, tags, subtitle, content, footer_data, isSubsLetterSend, isSubsLetterNotSend, isSubsLetterNotSendReason, meta, og } = storeToRefs(blogStore)

async function applySubEmail() {
  if (permissionToSend.value) {
    await blogStore.sendSubsEmail(subscribeEmail.value)
    subscribeEmail.value = ''
  }
}

usePageHeadMeta(meta.value.title, meta.value.description, og.value)
</script>


<style lang="scss" scoped>
.blog {
  &__container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas:
      "col-left"
      "blog-list"
      "footer";

    @media (--mobile-viewport-mf) {
      grid-template-columns: 216px 1fr;
      column-gap: 40px;
      grid-template-areas:
        "col-left blog-list"
        "footer footer";
    }

    @media (--small-viewport-mf) {
      column-gap: calc((100% - 907px) / 2);
    }

    @media (--medium-viewport-mf) {
      column-gap: calc(100% - 907px);
    }

    @media (--small-range-viewport) {
      padding-left: 5vw;
      padding-right: 5vw;
    }

    @media (--complex-screen) {
      padding-left: 10vw;
      padding-right: 10vw;
    }
  }

  &__col-left {
    grid-area: col-left;

    @media (--mobile-viewport-mf) {
      max-width: 250px;
    }
  }

  &__title,
  &__subtitle {
    color: var(--main-color);
  }

  &__title {
    font-size: 34px;
    margin-bottom: 25px;
  }

  &__subtitle {
    margin-bottom: 38px;

    &_desktop {
      display: none;

      @media (--mobile-viewport-mf) {
        display: block;
      }
    }

    &_mobile {
      margin-top: 107px;
      margin-bottom: 22px;

      @media (--mobile-viewport-mf) {
        display: none;
      }
    }

    &_email-send {
      width: 215px;
    }

    &_email-not-send {
      color: var(--purple-color);
      margin-top: 20px;
      font-size: 14px;
      font-weight: 600;
    }
  }

  &__btn-aside {
    width: inherit;

    @media (--extra-samll-viewport-mf) {
      width: var(--btn-width);
    }

    @media (--mobile-viewport-mf) {
      width: inherit;
    }
  }

  &__tag {
    display: block;
    text-transform: uppercase;
    color: var(--dark-color);
    font-size: 14px;
  }

  &__title-form {
    text-transform: uppercase;
    color: var(--main-color);
    margin-top: 130px;
    margin-bottom: 4px;
    display: none;

    @media (--medium-viewport-mf) {
      margin-top: 330px;
    }

    @media (--mobile-viewport-mf) {
      display: block;
    }
  }

  &__dialog-card {
    display: none;
    margin-top: 40px;

    @media (--mobile-viewport-mf) {
      display: block;
      margin-top: 162px;
    }
  }

  &__link {
    color: var(--main-color);
  }

  &__list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-top: 43px;
    grid-area: blog-list;

    @media (--mobile-viewport-mf) {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(217px, 1fr));
      column-gap: 20px;
      margin-top: 0;
    }

    @media (--medium-viewport-mf) {
      width: 691px;
    }

    @media (--small-range-viewport) {
      padding-left: 4vw;
    }
  }

  &__list-item {
    margin-bottom: 40px;

    @media (--mobile-viewport-mf) {
      margin-bottom: 0;
    }
  }

  &__footer {
    grid-area: footer;
  }
}

.subscribe {
  &__form {
    width: 100%;

    input {
      margin-bottom: 25px;
    }
  }

  &__checkbox {
    margin-bottom: 40px;
  }

  &__send-img {
    margin-bottom: 12px;
  }
}
</style>
